import { applySelectionMarkers } from './applySelectionMarkers';
import type { SelectionInfo } from '../../extract-paragraphs/selection/selectionTypes';
import type { DocParts } from '../../slate-api';
import { extractCastFromAlineDoc } from '../docx/extractCastFromAlineDoc';
import { expandCast } from '../expand';
import type { ExpandCastOptions } from '../expand';
import { serializeCast } from '../serialize';
import type { SerializeOptions } from '../serialize';

/**
 * End-to-end selection context for an Aline document: builds the Cast, places
 * the selection markers, expands around the selected paragraphs, and returns
 * the serialized string ready for an LLM.
 *
 * `selection` is the same `SelectionInfo` the editor already produces
 * (selected paragraph ids + optional start/end character offsets). The Slate
 * range → SelectionInfo conversion stays on the editor side; this function
 * never touches a live editor.
 *
 * The selected paragraph ids seed `expandCast`, so the result includes the
 * selection plus its surrounding context (neighbors, parent list items,
 * scoping headings, the full table) within the token budget.
 */
export function serializeSelectionContext(
  docParts: DocParts,
  selection: SelectionInfo,
  expandOptions: ExpandCastOptions,
  serializeOptions: SerializeOptions
): string {
  const root = extractCastFromAlineDoc(docParts);
  applySelectionMarkers(root, selection);
  expandCast(root, selection.selectedLocationIds, expandOptions, serializeOptions);
  return serializeCast(root, serializeOptions);
}
